var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { align: _vm.align } },
    [
      _c(
        "v-col",
        { class: _vm.classCol, attrs: { cols: _vm.cols } },
        [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
          _c("v-select", {
            attrs: {
              dense: "",
              outlined: "",
              "item-value": "value",
              "item-text": "text",
              disabled: _vm.disabled,
              loading: _vm.loading,
              items: _vm.$options.statuses,
              value: _vm.getStatus,
            },
            on: {
              change: function ($event) {
                return _vm.$emit("status:change", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }